module.exports = __webpack_public_path__ + "img/Shanxi-power.27ed0fb0.png";